import { useEffect } from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import styles from './PreviewModal.module.css'

interface PreviewModalProps {
  isOpen: boolean
  url: string
  title: string
  onClose: () => void
}

const PreviewModal = ({ isOpen, url, title, onClose }: PreviewModalProps) => {
  const { t } = useLanguage()
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className={`${styles.previewModal} ${isOpen ? styles.active : ''}`}>
      <div className={styles.modalOverlay} onClick={onClose}></div>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>{title || t('modal.preview')}</h3>
          <div className={styles.modalHeaderActions}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.visitSiteBtn}
            >
              {t('modal.visitSite')} →
            </a>
            <button className={styles.modalClose} onClick={onClose}>
              &times;
            </button>
          </div>
        </div>
        <div className={styles.modalIframeWrapper}>
          <iframe
            id="previewIframe"
            src={url}
            frameBorder="0"
            title={title}
          ></iframe>
        </div>
      </div>
    </div>
  )
}

export default PreviewModal
